import React, { useState } from 'react'
import MentorHeader from '../MentorHeader'
import { HomePageContainer } from '../MentorHomePage/MentorHomepageStyles'
import { FAQ_CATEGORIES } from 'src/consumer/constants'
import FaqSection from 'src/consumer/components/PrewallAndPaywall/FaqSection'
import { FAQ_LAYOUTS } from 'src/consumer/components/PrewallAndPaywall/faqComponents/utils'

export default function MentorFAQsPage() {

  return (
    <>
      <MentorHeader
        greetingsEnabled={true}
      />
      <HomePageContainer>
        <FaqSection categoryIds={[FAQ_CATEGORIES.my_profile_faqs, FAQ_CATEGORIES.incentive_plan_faqs]} fullWidth={true} layoutType={FAQ_LAYOUTS.TWO_COLUMN_SIDEBAR} />
        {/* <FaqSection categoryIds={[FAQ_CATEGORIES.event_booking_faqs, FAQ_CATEGORIES.therapist_booking_page_faqs]} fullWidth={true} /> */}
      </HomePageContainer>
    </>
  )
}
